import React from 'react';
import NavBar from './NavBar';
import Footer from './Footer';
import './PrivacyPolicy.css';

function PrivacyPolicy() {
  return (
    <div className="privacy-page">
      <NavBar />
      <main className="privacy-container">
        <div className="privacy-header">
          <h1>Política de Privacidad</h1>
          <p className="privacy-subtitle">openPDF — Branch Development</p>
          <span className="privacy-date">Última actualización: 19 de marzo de 2026</span>
        </div>

        <div className="privacy-content">
          <section className="privacy-section">
            <h2>1. Introducción</h2>
            <p>
              En <strong>Branch Development</strong> nos comprometemos a proteger tu privacidad.
              Esta Política de Privacidad describe cómo gestionamos la información cuando utilizas
              <strong> openPDF</strong>, nuestra herramienta de edición de documentos PDF disponible
              en la web.
            </p>
            <p>
              Al usar openPDF, aceptás los términos descritos en este documento.
            </p>
          </section>

          <section className="privacy-section">
            <h2>2. Información que NO recopilamos</h2>
            <p>
              openPDF funciona íntegramente en tu navegador (<strong>procesamiento local</strong>).
              Esto significa que:
            </p>
            <ul>
              <li>Los archivos PDF que abrís <strong>nunca se envían a nuestros servidores</strong>.</li>
              <li>No almacenamos el contenido de tus documentos en ninguna base de datos.</li>
              <li>No requerimos registro ni creación de cuenta.</li>
              <li>No solicitamos ni almacenamos información personal identificable (nombre, email, etc.).</li>
            </ul>
          </section>

          <section className="privacy-section">
            <h2>3. Datos técnicos y de uso</h2>
            <p>
              Como parte del funcionamiento normal del sitio web, podemos registrar de forma
              anónima información técnica mínima, incluyendo:
            </p>
            <ul>
              <li>Dirección IP anonimizada.</li>
              <li>Tipo y versión de navegador.</li>
              <li>Páginas visitadas y duración aproximada de la sesión.</li>
              <li>País o región de acceso (a nivel general).</li>
            </ul>
            <p>
              Esta información se utiliza exclusivamente para analizar el rendimiento del sitio
              y mejorar la experiencia de uso. No se vincula a ninguna identidad personal.
            </p>
          </section>

          <section className="privacy-section">
            <h2>4. Cookies</h2>
            <p>
              Podemos utilizar cookies técnicas estrictamente necesarias para el funcionamiento
              del sitio (por ejemplo, para guardar preferencias de sesión). No utilizamos cookies
              de seguimiento publicitario ni compartimos datos con redes de publicidad.
            </p>
            <p>
              Podés gestionar o deshabilitar las cookies desde la configuración de tu navegador
              en cualquier momento.
            </p>
          </section>

          <section className="privacy-section">
            <h2>5. Almacenamiento local del navegador</h2>
            <p>
              openPDF puede utilizar el <strong>almacenamiento local</strong> (localStorage) de tu
              navegador para guardar configuraciones de la herramienta (como preferencias de
              visualización). Estos datos permanecen únicamente en tu dispositivo y no son
              accesibles para nosotros.
            </p>
          </section>

          <section className="privacy-section">
            <h2>6. Servicios de terceros</h2>
            <p>
              El sitio puede depender de servicios de terceros para su funcionamiento, tales como:
            </p>
            <ul>
              <li><strong>Proveedores de hosting</strong> para alojar el sitio web.</li>
              <li><strong>Bibliotecas de código abierto</strong> para el procesamiento de PDFs
              (procesadas localmente en tu navegador).</li>
            </ul>
            <p>
              Estos servicios pueden tener sus propias políticas de privacidad. Te recomendamos
              revisarlas en sus respectivos sitios.
            </p>
          </section>

          <section className="privacy-section">
            <h2>7. Seguridad de los datos</h2>
            <p>
              Dado que el procesamiento de tus archivos ocurre íntegramente en tu navegador,
              el riesgo de exposición de tus documentos a través de nuestra plataforma es mínimo.
              Recomendamos no usar openPDF en dispositivos públicos o compartidos cuando trabajes
              con documentos sensibles.
            </p>
          </section>

          <section className="privacy-section">
            <h2>8. Derechos del usuario</h2>
            <p>
              Dado que no recopilamos datos personales identificables, no existe información
              almacenada sobre vos en nuestros sistemas que pueda ser eliminada, modificada o
              exportada. Sin embargo, si tenés alguna consulta al respecto, podés contactarnos.
            </p>
          </section>

          <section className="privacy-section">
            <h2>9. Cambios en esta política</h2>
            <p>
              Podemos actualizar esta Política de Privacidad periódicamente. En caso de cambios
              significativos, actualizaremos la fecha indicada al inicio del documento. Te
              recomendamos revisar esta página ocasionalmente.
            </p>
          </section>

          <section className="privacy-section">
            <h2>10. Contacto</h2>
            <p>
              Si tenés preguntas o inquietudes sobre esta Política de Privacidad, podés
              comunicarte con nosotros a través de nuestra{' '}
              <a href="/#/contacto" className="privacy-link">página de contacto</a>.
            </p>
          </section>
        </div>
      </main>
      <Footer />
    </div>
  );
}

export default PrivacyPolicy;
